import { PreferencesAPIModel, PreferencesModel } from '@models/Preferences';
import { SitesShowFilter } from '../Maps/Togglers';
import { EMetricSystem } from '@models/EMetricSystem';
import { CountriesDateFormats, CountriesType, CustomSelectItem, formatDateWithCustomCountry } from '@hwm/ui-lib';

export const defaultPreferencesValues: PreferencesModel = {
  /// map
  showLNS: false,
  showCSQ: false,
  showName: false,
  showOption: SitesShowFilter.ShowAllSites,
  showGIS: true,
  showGISPipeData: false,
  showGISPipeInformation: false,
  gisPipeMetricSystem: EMetricSystem.Metric,
  showGISAssetsData: false,
  showGISAssetIds: false,
  showGISDMAData: false,
  showCorrelations: false,
  showHighConfidenceOnly: false,
  showGISCorrelations: false,
  showSurveyMeasurements: false,
  showPRVLogger: false,
  showFlowLogger: false,
  showPressureLogger: false,
  showFlowPressureLogger: false,
  showSitesWithoutLocation: false,
  // functions
  uploadSiteNoteDateFormat: 'en-GB',
};

export const uploadSiteNoteDateFormatOptions = (): CustomSelectItem[] => {
  const dateFormats = Array.from(new Set(Object.values(CountriesDateFormats)));
  return dateFormats.map((df) => {
    const country = (Object.entries(CountriesDateFormats).find(([_, format]) => format === df)?.[0] ??
      'en-GB') as CountriesType;
    return {
      label: `${df} (${formatDateWithCustomCountry(new Date(2024, 6, 3, 9, 40), country)})`,
      value: country,
    };
  });
};

export const mapPreferencesFromApi = (data: PreferencesAPIModel): PreferencesModel => {
  const { uploadSiteNoteDateFormat, ...restOfData } = data;

  const parsedUploadSiteNoteDateFormat = (Object.entries(CountriesDateFormats).find(
    ([_, format]) => format === uploadSiteNoteDateFormat
  )?.[0] ?? 'en-GB') as CountriesType;

  return {
    ...restOfData,
    uploadSiteNoteDateFormat: parsedUploadSiteNoteDateFormat,
  };
};

export const mapPreferencesToApi = (data: PreferencesModel): PreferencesAPIModel => {
  const { uploadSiteNoteDateFormat, ...restOfData } = data;

  const parsedUploadSiteNoteDateFormat = CountriesDateFormats[uploadSiteNoteDateFormat as CountriesType];

  return {
    ...restOfData,
    uploadSiteNoteDateFormat: parsedUploadSiteNoteDateFormat,
  };
};
